module.exports = __webpack_public_path__ + "static/media/ANDHRA.49379499.svg";